import { HStack, Button, Badge, IconButton, Flex, Box, Collapsible } from '@chakra-ui/react';
import {
  FiCrosshair,
  FiTag,
  FiDownload,
  FiMapPin,
  FiX,
  FiChevronUp,
  FiChevronDown,
} from 'react-icons/fi'
import { useState } from 'react'

interface ActionBarProps {
  isDrawing: boolean
  polygonWkt: string | null
  onDrawSelection: () => void
  onClearPolygon: () => void
  onApplyTags: () => void
  onExportToList: () => void
  onCreateTurf: () => void
}

export function ActionBar({
  isDrawing,
  polygonWkt,
  onDrawSelection,
  onClearPolygon,
  onApplyTags,
  onExportToList,
  onCreateTurf,
}: ActionBarProps) {
  const [expanded, setExpanded] = useState(true)

  return (
    <Box bg="surface" borderBottom="1px" borderColor="gray.200">
      <Collapsible.Root open={expanded}>
        <Collapsible.Content>
          <Flex px={3} py={2} align="center" gap={2}>
            <HStack gap={2} flex={1} flexWrap="wrap">
              <Button
                size="sm"
                colorPalette={isDrawing ? 'orange' : 'blue'}
                variant={isDrawing ? 'solid' : 'outline'}
                onClick={onDrawSelection}><FiCrosshair />{isDrawing ? 'Drawing...' : 'Draw Selection'}</Button>

              {(polygonWkt || isDrawing) && (
                <Button size="sm" variant="ghost" onClick={onClearPolygon}><FiX />Clear
                                </Button>
              )}

              {polygonWkt && (
                <Badge colorPalette="green" fontSize="xs" py={0.5} px={2}>
                  Selection active
                </Badge>
              )}

              <Box w="1px" h={5} bg="gray.300" mx={1} />

              <Button size="sm" variant="outline" onClick={onApplyTags}><FiTag />Apply Tags
                            </Button>

              <Button size="sm" variant="outline" onClick={onExportToList}><FiDownload />Export to List
                            </Button>

              <Button size="sm" variant="outline" onClick={onCreateTurf}><FiMapPin />Create Turf
                            </Button>
            </HStack>
          </Flex>
        </Collapsible.Content>
      </Collapsible.Root>

      <Flex justify="center">
        <IconButton
          aria-label={expanded ? 'Hide action bar' : 'Show action bar'}
          variant="ghost"
          size="xs"
          onClick={() => setExpanded(!expanded)}
          h={4}
          minW="60px"
          borderRadius={0}>{expanded ? <FiChevronUp /> : <FiChevronDown />}</IconButton>
      </Flex>
    </Box>
  );
}
